var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content make-invoice" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { lazy: true, type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _vm.$checkPermission(["tab_tabMakeInvoice"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("Invoice.invoice_drawCollectInvoice"),
                      name: "makeInvoice"
                    }
                  },
                  [
                    _c("tab-make-invoice", {
                      attrs: { "is-show": _vm.makeInvoiceIsShow }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.$checkPermission(["tab_tabQueryInvoice"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      lazy: true,
                      label: _vm.$t("Invoice.invoice_queryInvoice"),
                      name: "queryInvoice"
                    }
                  },
                  [
                    _c("tab-invoice-query", {
                      attrs: { "is-show": _vm.queryInvoiceIsShow }
                    }),
                    _vm._v("` ")
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }